import { Community as CommunityTypes } from '../types'

const {
  REQUEST_FETCH_COMMUNITYS,
  FETCH_COMMUNITYS_ERROR,
  FETCH_COMMUNITYS_SUCCESS,
  RESET_COMMUNITY
} = CommunityTypes

const initialState = {
  communitys: [],
  isLoading: false,
  errors: {
    status: false,
    message: null
  }
}

export default (state = initialState, action) => {
  switch (action.type) {

    case REQUEST_FETCH_COMMUNITYS:
      return {
        ...state,
        isLoading: true,
        errors: {
          ...state.errors,
          status: false,
          message: null
        }
      }

    case FETCH_COMMUNITYS_SUCCESS:
      return {
        ...state,
        communitys: action.payload.communitys,
        isLoading: false,
        errors: {
          ...state.errors,
          status: false,
          message: null
        }
      }

    case FETCH_COMMUNITYS_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: {
          ...state.errors,
          status: true,
          message: action.payload.message
        }
      }

    case RESET_COMMUNITY:
      return {
        ...state,
        isLoading: false,
        errors: {
          ...state.errors,
          status: false,
          message: null
        }
      }

    default:
      return state

  }
}
